import React from "react";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  details?: any;
}

const ActivateUserModal = ({ onClose, visible, details }: myComponentProps) => {
  return (
    <>
      <ReuseModal
        visible={visible}
        onClose={onClose}
        deleteType
        btnColor="black-light"
        btnLabel="Activate User"
        title="Activate User  Account"
        deleteText="Are you sure you want to delete this user's profile. "
      />
    </>
  );
};

export default ActivateUserModal;
